import { render, staticRenderFns } from "./ProviderDelete.vue?vue&type=template&id=5fe31c7a"
import script from "./ProviderDelete.vue?vue&type=script&lang=js"
export * from "./ProviderDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports